// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k2Qs3","label":"styles_label__1pbJV"};